import { render } from "./GallerySlick.vue?vue&type=template&id=932fd366"
import script from "./GallerySlick.vue?vue&type=script&lang=js"
export * from "./GallerySlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/GallerySlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "932fd366"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('932fd366', __exports__)) {
    api.reload('932fd366', __exports__)
  }
  
  module.hot.accept("./GallerySlick.vue?vue&type=template&id=932fd366", () => {
    api.rerender('932fd366', render)
  })

}


export default __exports__